const Link = dynamic(() => import('next/link'));
import dynamic from 'next/dynamic';
import Image from 'next/image';

export enum PAGE_OPTIONS {
  DAY_TOUR_PAGED = 'dayTours',
  MULTIDAY_TOUR_PAGE = 'multiday'
}

interface PAGE {
  page?: PAGE_OPTIONS;
}
const data = [
  {
    id: 'B111',
    snippet: 'Small-Group Tours',
    icon: '/small-group-tours.svg',
    link: '/tours'
  },
  {
    id: 'B112',
    snippet: 'Free Cancellation',
    icon: '/Free_Cancellation.svg',
    link: '/faq'
  },
  {
    id: 'B113',
    snippet: '6000+ 5-Star Reviews',
    icon: '/star-reviews.svg',
    link: '/reviews'
  }
];
const Trustbar = () => {
  return (
    <section
      id="trusbar"
      className=" py-5 mx-5 sm:mx-20 md:mx-20 lg:mx-32 2xl:mx-40 "
    >
      <div id="experience" className="flex justify-center text-white ">
        {data.map(dt => {
          return (
            <div key={dt.id}>
              <Link href={dt.link}>
                <div className="flex flex-col gap-3 2xl:gap-5 justify-between items-center h-full px-2 sm:px-10 ">
                  <div className="flex-none ">
                    <Image
                      src={dt.icon}
                      width={40}
                      height={40}
                      alt="trust us"
                      priority
                      className=" w-8  md:w-10  "
                    />
                  </div>

                  <p className="flex-none  text-[12px] md:text-[14px] lg:text-[16px] text-[#2F2E2E] text-center font-[400]">
                    {dt.snippet}
                  </p>
                </div>
              </Link>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Trustbar;
